import posthog from "posthog-js";

let isInitialized = false;

export function initAnalytics() {
  console.log("[PostHog] initAnalytics called");
  if (typeof window === "undefined") return;
  if (isInitialized) return;
  
  const key = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
  const host = import.meta.env.VITE_PUBLIC_POSTHOG_HOST || "https://eu.i.posthog.com";
  
  console.log("[PostHog] Config:", { hasKey: !!key, keyPrefix: key ? key.slice(0, 8) : "none", host });

  if (!key) {
    console.warn("[PostHog] Key missing. Analytics disabled.");
    isInitialized = true; 
    return;
  }

  try {
    if (!posthog) {
      console.error("[PostHog] posthog-js import is null or undefined!");
      return;
    }

    posthog.init(key, {
      api_host: host,
      capture_pageview: true,
      capture_pageleave: true,
      persistence: "localStorage",
      person_profiles: "identified_only",
      debug: true,
    });
    isInitialized = true;
    console.log("[PostHog] Initialized successfully.");
  } catch (err) {
    console.error("[PostHog] Error during initialization:", err);
  }
}

/** Identify the user in PostHog. */
export function identify(userId: string, properties?: Record<string, unknown>) {
  if (!isInitialized) initAnalytics();
  console.log("[PostHog] Identifying user:", userId);
  posthog.identify(userId, properties);
}

/** Thin wrapper — import this everywhere instead of posthog directly. */
export function capture(event: string, properties?: Record<string, unknown>) {
  if (!isInitialized) initAnalytics();
  console.log("[PostHog] Capturing event:", event, properties);
  posthog.capture(event, properties);
}
